import React from 'react';
import { Card } from 'app/javascript/components/ui/card';

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  sublabel?: string;
}

export default function StatCard({ icon, label, value, sublabel }: StatCardProps) {
  return (
    <Card className="gap-1 p-4">
      <div className="flex items-center gap-2 text-muted-foreground">
        {icon}
        <span className="text-xs font-medium uppercase tracking-wide">{label}</span>
      </div>
      <p className="font-bebas text-3xl text-foreground">{value.toLocaleString('pt-BR')}</p>
      {sublabel && <p className="text-xs text-yellow-400">{sublabel}</p>}
    </Card>
  );
}
